import { EVENT_NAME } from "./constants";
import { getTrackAction, mapToSnakeCase } from "./utils";
import ConsoleLogger from "./ConsoleLogger";

const assertsContext = context => {
  if (!(typeof context === "object")) {
    throw new Error("context must be an object");
  }
};

const assertsLoggerInstance = logger => {
  if (!(typeof logger === "object")) {
    throw new Error("logger must be an object");
  }

  if (!(typeof logger.logEvent === "function")) {
    throw new Error("logger must implement logEvent method");
  }
};

const assertsProjectInstance = projectRef => {
  if (!(typeof projectRef === "string") || !projectRef) {
    throw new Error("projectRef params is required");
  }
};

class Tracker {
  constructor(options) {
    if (!(options && typeof options === "object")) {
      throw new Error("options must be an object");
    }

    assertsProjectInstance(options.projectRef);
    this.debug = !!options.debug;
    const prodLogger = options.analytics || options.logger;
    this.logger = this.debug ? ConsoleLogger : prodLogger;
    this.context = {
      projectRef: options.projectRef,
      interfaceId: null
    };
    this.localContext = {};
  }

  logEvent(payload) {
    const [actionId, params] = getTrackAction(payload);

    if (actionId) {
      this.logger.logEvent(EVENT_NAME, {
        action_id: actionId,
        ...params,
        ...mapToSnakeCase(this.context),
        ...mapToSnakeCase(this.localContext)
      });
    }
  }

  setLogger(logger) {
    assertsLoggerInstance(logger);
    this.logger = logger;
  }

  setContext(context) {
    assertsContext(context);
    this.context = { ...this.context,
      ...context
    };
  }

  setLocalContext(context) {
    assertsContext(context);
    this.localContext = context;
  }

  setInterfaceId(interfaceId) {
    this.setContext({
      interfaceId
    });
  }

  getInterfaceId() {
    return this.context.interfaceId;
  }

}

export default Tracker;